import { PLAN_TIERS } from 'src/sections/pricing/pricing-plans-grid';

export type PlanChangeType = 'upgrade' | 'downgrade' | 'lateral';

export function getTierIndexSafe(tag: string | null | undefined): number | null {
  if (!tag) return null;
  const idx = PLAN_TIERS.indexOf(tag as (typeof PLAN_TIERS)[number]);
  return idx === -1 ? null : idx;
}

export function getPlanChangeType(
  fromPlan: string | null | undefined,
  toPlan: string | null | undefined
): PlanChangeType {
  if (!fromPlan || !toPlan || fromPlan === toPlan) {
    return 'lateral';
  }

  const fromIdx = getTierIndexSafe(fromPlan);
  const toIdx = getTierIndexSafe(toPlan);

  if (fromIdx === null || toIdx === null) {
    return 'lateral';
  }

  if (toIdx > fromIdx) {
    return 'upgrade';
  }

  if (toIdx < fromIdx) {
    return 'downgrade';
  }

  return 'lateral';
}
